// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2LrqC","icon":"SortAdornment_icon__29E__","up":"SortAdornment_up__3A4JI","down":"SortAdornment_down__3BP64","active":"SortAdornment_active__3BfK2"};